import { PlusOutlined } from "@ant-design/icons";
import { Button, Divider } from "antd";
import { useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import AppContext from "../../context/app/context";
import UnitPartitionContext from "../../context/unit-partition/context";
import UnitPartitionContextProvider from "../../context/unit-partition/provider";
import SearchFilterCard from "../../components/general/filter-card";
import Can from "../../utils/rbac/can";
import PageHeader from "../../components/general/layout/page-header";
import RefreshBtn from "../../components/general/table-components/actions/refresh-btn";
import { CAN_VIEW_HOME_PAGE } from "../../utils/rbac/permissions";
import UnitPartitionTable from "../../components/unit-partition/unit-partition-table";

const UnitPartitionPage: React.FC = () => {
  const { t } = useTranslation();
  const { direction } = useContext(AppContext);
  const navigate = useNavigate();
  const [search, setSearch] = useState<string | undefined>(undefined);
  const { actions, loading, query } = useContext(UnitPartitionContext);

  useEffect(() => {
    actions.setSearch(search);
  }, [search]);

  useEffect(() => {
    actions.getData();
  }, [query, direction]);

  return (
    <div dir={direction}>
      <PageHeader
        title={t("unit_partitions")}
        subTitle={t("unit_partition_management")}
        extra={[
          <RefreshBtn key={0} loading={loading.includes("list")} onClick={() => actions.getData()}>
            {t("refresh")}
          </RefreshBtn>,
          <Divider key={1} type="vertical" />,
          <Can key={2} perform={CAN_VIEW_HOME_PAGE}>
            <Button type="primary" onClick={() => navigate(`/unit-partitions/create`)} icon={<PlusOutlined />}>
              {t("add_unit_partition")}
            </Button>
          </Can>
        ]}
      />
      <SearchFilterCard
        formId="unit-partition-filter"
        searchValue={search}
        setSearchValue={setSearch}
        onReset={() => {
          actions.setQuery({
            page: query?.page,
            perPage: query?.perPage,
          });
          const form = document.getElementById("unit-partition-filter");
          if (form) {
            form.dispatchEvent(new Event("reset", { cancelable: true, bubbles: true }));
          }
        }}
        resetLoading={loading.includes("list")}
        applyLoading={loading.includes("list")}
      >
        {/* <UserFilter /> */}
      </SearchFilterCard>
      <UnitPartitionTable />
    </div>
  );
};

const UnitPartitionWrapper = () => (
  <UnitPartitionContextProvider>
    <UnitPartitionPage />
  </UnitPartitionContextProvider>
);

export default UnitPartitionWrapper;
